import { Icon } from '@iconify/react';
import React from 'react';
import { Link } from 'react-router-dom';

export default function SocialWidget({ data }) {
  return (
    <div className='cs_social_links_wrap'>
      <h2>Theo dõi chúng tôi</h2>
      <div className='cs_social_links'>
        {data?.facebook && (
          <Link to={data?.facebook} target='_blank' rel='noopener noreferrer'>
            <Icon icon='fa-brands:facebook-f' />
          </Link>
        )}

        {data?.youtube && (
          <Link to={data?.youtube} target='_blank' rel='noopener noreferrer'>
            <Icon icon='fa-brands:youtube' />
          </Link>
        )}

        {data?.x && (
          <Link to={data?.x} target='_blank' rel='noopener noreferrer'>
            <Icon icon='fa-brands:twitter' />
          </Link>
        )}

        {data?.instagram && (
          <Link to={data?.instagram} target='_blank' rel='noopener noreferrer'>
            <Icon icon='fa-brands:instagram' />
          </Link>
        )}
      </div>
    </div>
  );
}
